// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"d4e16624","298":"015d993c","570":"fb490396","722":"6d3ba366","763":"243d0a9a","912":"42043ff6","929":"878de1a3"}[chunkId] + ".chunk.js";
};